import EditIcon from "@mui/icons-material/Edit";
import { Zoom } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { alpha, lighten, styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";

const CustomizedComponent = styled(IconButton)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: `none`,
  color: alpha(theme.palette.foreground.contrastText, 0.25),
  transform: "scale(1)",
  transformOrigin: "center",
  transition: "all 0.05s ease-out",
  "&:hover, :active": {
    transform: "scale(1.095)",
    background: alpha(lighten(theme.palette.secondary.main, 0.75), 0.6),
    "& .MuiSvgIcon-root": {
      fill: theme.palette.secondary.main,
    },
  },
  "&:active": {
    boxShadow: `inset 0px 0px 3px ${alpha(lighten(theme.palette.secondary.main, 0.35), 0.6)}`,
    transform: "scale(0.98)",
  },
}));

const OmniGridButton = props => {
  const {
    title = "Edit",
    placement = "left",
    size = "small",
    icon = <EditIcon fontSize="medium" />,
  } = props;

  let buttonProps = { ...props };
  delete buttonProps.title;
  delete buttonProps.placement;
  delete buttonProps.icon;

  return (
    <Tooltip
      title={title}
      placement={placement}
      disableInteractive
      enterDelay={500}
      enterNextDelay={500}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 200, easing: "ease-in-out" }}
    >
      <>
        <CustomizedComponent size={size} {...buttonProps}>
          {icon}
        </CustomizedComponent>
      </>
    </Tooltip>
  );
};

export default OmniGridButton;
